<template>
  <div
    class="base-container"
  >
    <BannerView />
    <MnetdInfoView />
    <ServicesSection />
    <EndingView />
  </div>
</template>

<script>
import BannerView from "./components/Banner.vue";
import MnetdInfoView from "./components/MnetdInfo.vue";
import ServicesSection from "./components/ServicesSection.vue";
import EndingView from "./components/Ending.vue";


export default {
    name: "TopPage",
    components: {
        BannerView,
        MnetdInfoView,
        ServicesSection,
        EndingView,
    }
};

</script>

<style lang="scss" scoped>

.base-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto;
  max-width: 1600px;
  width: 100%;
  padding: 0 5%;
  box-sizing: border-box;
}

@media screen and (max-width: 1060px) {
  .base-container {
    padding: 0 10px; 
    width: 100%; 
    max-width: 95%;
  }
}

</style>